module.exports = __webpack_public_path__ + "static/img/woocommerce.8f372b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/woocommerce.png
// module id = vf9Y
// module chunks = 0 139